import { DistanceCoordinate } from '@leid/api-locations'

import { SortingInfo } from 'appTypes/mapper'

import { CustomerInfo } from './authentication'

export const getDistanceCoordinates = (
  sortingInfo: SortingInfo | undefined,
  customerInfo: CustomerInfo,
): DistanceCoordinate | undefined => {
  if (sortingInfo) {
    return {
      latitudeCoordinate: sortingInfo.lat,
      longitudeCoordinate: sortingInfo.long,
    }
  }

  if (customerInfo.customer) {
    return {
      latitudeCoordinate: customerInfo.customer.coordinates?.latitude,
      longitudeCoordinate: customerInfo.customer.coordinates?.longitude,
    }
  }

  return undefined
}
